module.exports = __webpack_public_path__ + "static/media/placeholder_image.98344143.png";